import { render, staticRenderFns } from "./InstallAppInfoCard.vue?vue&type=template&id=9a706ddc"
import script from "./InstallAppInfoCard.vue?vue&type=script&lang=js"
export * from "./InstallAppInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports